// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Enums
import {
  RegattaDocumentStatus,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputDateTime,
  InputDoubleButton,
  InputFile,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  regattaDocumentStatusLabel,
} from 'common.language';
import config from '../../../config';

// Types
import type {
  $ReducerState,
} from '../../../redux';

type $OptionalProps = {
  admin?: boolean;
};

export type $OwnProps = $OptionalProps & $Translate & {
  item: $Model<'ChampionshipDocument'> | $ModelUpsertParams<'ChampionshipDocument'>;
};

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

type $State = {
  contentType: 'file' | 'text';
};

class ChampionshipDocumentFieldsView extends React.Component<$Props, $State> {
  static defaultProps: $OptionalProps = {
    admin: undefined,
  };

  constructor(props: $Props) {
    super(props);

    const {
      File,
      id,
    } = props.item;

    this.state = {
      contentType: !id || File !== null ? 'file' : 'text',
    };
  }

  render() {
    const {
      admin,
      item,
      main,
      t,
    } = this.props;
    const {
      contentType,
    } = this.state;

    return (
      <>
        <Row>
          <Col sm={4}>
            <InputDoubleButton
              className={'mb-3'}
              label={t('Visibility')}
              labelFalse={t('Hidden')}
              labelTrue={t('Visible')}
              name={'Public'}
              value={item.Public}
            />
          </Col>
          <Col
            sm={8}
            xs={12}
          >
            <AvField
              label={t('Title')}
              name={'Name'}
              required
              value={item.Name}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <InputDateTime
              label={t('Document date')}
              labelOpenCalendar={t('Open calendar')}
              name={'DocumentDate'}
              required
              timezone={main.timezone}
              value={item.DocumentDate}
            />
          </Col>
          <Col sm={6}>
            <InputDateTime
              disabled
              label={t('Publish date')}
              labelOpenCalendar={t('Open calendar')}
              name={'PublishDate'}
              timezone={main.timezone}
              value={item.PublishDate}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Nav
              justified
              tabs
            >
              <NavItem>
                <NavLink
                  className={`${contentType === 'file' ? 'active' : ''}`}
                  onClick={() => this.setState({
                    contentType: 'file',
                  })}
                >
                  {t('Document as PDF file')}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={`${contentType === 'text' ? 'active' : ''}`}
                  onClick={() => this.setState({
                    contentType: 'text',
                  })}
                >
                  {t('Document as free text')}
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent
              activeTab={contentType}
              className={'mb-3'}
            >
              <TabPane tabId={'file'}>
                <InputFile
                  fileDirUrl={`${config.CDN_URL}/files`}
                  label={t('File')}
                  labelChangeFile={t('Change file')}
                  labelError={t('Error')}
                  labelFile={t('File')}
                  name={'File'}
                  onError={ErrorLog.exception}
                  required={contentType === 'file'}
                  uploadUrl={`${config.CDN_URL}/v1.0/upload/file`}
                  value={item.File}
                />
              </TabPane>
              <TabPane tabId={'text'}>
                <AvField
                  label={t('Content')}
                  name={'Content'}
                  required={contentType === 'text'}
                  type={'textarea'}
                  value={item.Content}
                />
              </TabPane>
            </TabContent>
          </Col>
        </Row>
        {admin && (
          <Row>
            <Col>
              <AvField
                label={t('Status')}
                name={'Status'}
                required
                type={'select'}
                value={item.Status}
              >
                {_.map(
                  RegattaDocumentStatus,
                  (i) => (
                    <option
                      key={i}
                      value={i}
                    >
                      {t(regattaDocumentStatusLabel[i])}
                    </option>
                  ),
                )}
              </AvField>
            </Col>
            <Col>
              <AvField
                label={t('Status description')}
                name={'StatusContent'}
                value={item.StatusContent}
              />
            </Col>
          </Row>
        )}
      </>
    );
  }
}

export default ChampionshipDocumentFieldsView;
